import { createFileRoute } from '@tanstack/react-router';

import { CreateAccountPage } from '../pages/CreateAccountPage';

interface CreateSearch {
  /** The origin of the Direwolf AI app that sent the person here (checked on use). */
  return?: string;
}

export const Route = createFileRoute('/create')({
  validateSearch: (search: Record<string, unknown>): CreateSearch =>
    typeof search.return === 'string' ? { return: search.return } : {},
  component: CreateRoute,
});

function CreateRoute() {
  const search = Route.useSearch();
  return <CreateAccountPage returnParam={search.return} />;
}
